export * from './components/StaticList/index';
